import { getEditableField, setEditableFieldValue } from '../../../store';
import { removeUnicode } from '../../../../components/rich-text-editor';
export var initializeSmsContent = function (_a) {
    var store = _a.store;
    var state = store.getState();
    var smsContent = getEditableField(state, 'smsBody').value;
    var titleContent = getEditableField(state, 'emailTitle').value;
    if (!smsContent && !!titleContent) {
        var cleanedTitle = removeUnicode(titleContent);
        store.dispatch(setEditableFieldValue({ name: 'smsBody', value: cleanedTitle }));
    }
};
